import {AddPostButtonContainer} from '../../newCommunityPost/components';
import UserProfileMenu from './UserProfileMenu';
import React, {PropTypes} from 'react';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';

export default function PageHeader({title}) {
  const titleStyle = {
    paddingLeft: 263,
  };

  return (
    <div className="page-header">
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={title} style={titleStyle} />
        </ToolbarGroup>
        <ToolbarGroup>
          <AddPostButtonContainer />
          <UserProfileMenu />
        </ToolbarGroup>
      </Toolbar>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/features/layout/components/PageHeader.js